import {
	SEARCH_REQUEST,
	SEARCH_FAILURE,
	SEARCH_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	results: {},
	message: {
		type: '',
		text: '',
	},
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case SEARCH_REQUEST:
			return {
				...state,
				isFetching: true,
				results: {},
				message: {
					type: '',
					text: '',
				},
			};

		case SEARCH_FAILURE:
			return {
				...state,
				isFetching: false,
				results: {},
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case SEARCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				results: payload.results,
				message: {
					type: '',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/search.js